import * as Sentry from '@sentry/vue';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export default function sentry(app, router) {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Sem `release` o requestx devolve os frames do stacktrace sem traduzir -
    // o resolver de source map casa artefato por release. O CI injeta o SHA.
    release: import.meta.env.VITE_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
  });
}
